import { render, staticRenderFns } from "./CalciatoreBattuto.vue?vue&type=template&id=10598ffc&scoped=true&"
import script from "./CalciatoreBattuto.vue?vue&type=script&lang=js&"
export * from "./CalciatoreBattuto.vue?vue&type=script&lang=js&"
import style0 from "./CalciatoreBattuto.vue?vue&type=style&index=0&id=10598ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10598ffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10598ffc')) {
      api.createRecord('10598ffc', component.options)
    } else {
      api.reload('10598ffc', component.options)
    }
    module.hot.accept("./CalciatoreBattuto.vue?vue&type=template&id=10598ffc&scoped=true&", function () {
      api.rerender('10598ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CalciatoreBattuto.vue"
export default component.exports